import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { useProfileStore } from 'src/features/stores/useProfileStore';
import { getAxios } from 'src/lib/axios';

const checkPersonalCardAvailableQuery = async (isPersonalMode: boolean, selectedUserId: number): Promise<boolean> => {
  let url = `/api/onlinebookingprofile/checkPersonalCardAvailableQuery/${isPersonalMode}/?`;
  url += '&contactId=' + selectedUserId;
  return (await getAxios().get(url, {})).data;
};

export const useCheckPersonalCardAvailableQuery = (isPersonalMode: boolean, enabled: boolean) => {
  const location = useLocation();
  const isHotelSearchPage = location.pathname.startsWith('/hotel-search');
  const { selectedUserId } = useProfileStore();

  return useQuery({
    queryKey: ['checkPersonalCardAvailableQuery', isPersonalMode, selectedUserId, isHotelSearchPage],
    queryFn: () => checkPersonalCardAvailableQuery(isPersonalMode, selectedUserId!),
    enabled: enabled && !!selectedUserId && isHotelSearchPage // <--- only runs when selectedUserId is available
  });
};
